var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-container",on:{"click":function($event){return _vm.handleScreenClick()}}},[_c('div',{attrs:{"id":"p5Canvas"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }